import { Controller } from "@hotwired/stimulus"

// Brings its element into view once it is on the page. Used where the server
// knows the operator should land somewhere other than the top — returning from
// a sample upload to the card they left from. A URL fragment cannot do this
// here: a Turbo visit does not carry it through, and the page scrolls inside
// <main> rather than the window.
//
// Scrolling the card into view is also what loads the preview frame inside it,
// which is loading="lazy" and therefore waits for the card to be seen.
export default class extends Controller {
  connect() {
    this.element.scrollIntoView({ block: "start" })
  }
}
